/**
 * 画面で使う小さな線画アイコン（自作。外部のアイコン集は使わない）。
 * 意味は必ず文字でも出す（アイコンだけのボタンには aria-label を付ける）。ここでは常に aria-hidden。
 */
const PATHS = {
  home: "M3 11.5 12 4l9 7.5M5.5 9.5V20h5v-6h3v6h5V9.5",
  bell: "M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15L6 16Zm4 3.5a2 2 0 0 0 4 0",
  report: "M12 5v14M5 12h14",
  doc: "M7 3h7l4 4v14H7V3Zm7 0v4h4M10 12h6M10 16h6",
  menu: "M4 7h16M4 12h16M4 17h16",
  search: "M10.5 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm4.6-1.9L20 20",
  close: "M6 6l12 12M18 6 6 18",
  check: "M5 12.5 10 17l9-10",
  chevron: "M9 5l7 7-7 7",
  back: "M15 5l-7 7 7 7",
  book: "M4 5.5C6.5 4 9.5 4 12 5.5 14.5 4 17.5 4 20 5.5V19c-2.5-1.5-5.5-1.5-8 0-2.5-1.5-5.5-1.5-8 0V5.5ZM12 5.5V19",
  alert: "M12 4 21 19H3L12 4Zm0 6v4m0 2.5v.5",
  clock: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-13v4.5l3 2",
  table: "M4 5h16v14H4V5Zm0 5h16M4 14.5h16M9.5 5v14",
  list: "M9 6h11M9 12h11M9 18h11M4.5 6h.5M4.5 12h.5M4.5 18h.5",
  chart: "M4 20V10m5.5 10V4M15 20v-7m5.5 7V8",
  users: "M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-6 9c.5-3.5 3-5.5 6-5.5s5.5 2 6 5.5M16 4.3a3.5 3.5 0 0 1 0 6.4M18 14.8c1.8.7 3 2.4 3.3 5.2",
  gear: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7.4-3a7.4 7.4 0 0 0-.1-1.3l2-1.6-2-3.4-2.4 1a7.4 7.4 0 0 0-2.2-1.3L14.4 3h-4l-.4 2.4a7.4 7.4 0 0 0-2.2 1.3l-2.4-1-2 3.4 2 1.6a7.4 7.4 0 0 0 0 2.6l-2 1.6 2 3.4 2.4-1a7.4 7.4 0 0 0 2.2 1.3l.4 2.4h4l.4-2.4a7.4 7.4 0 0 0 2.2-1.3l2.4 1 2-3.4-2-1.6c.1-.4.1-.9.1-1.3Z",
  grid: "M4 4h7v7H4V4Zm9 0h7v7h-7V4ZM4 13h7v7H4v-7Zm9 0h7v7h-7v-7Z",
  logout: "M10 4H5v16h5M15 8l4 4-4 4M19 12H9",
  copy: "M8 8h11v12H8V8Zm-3 8V4h11",
  refresh: "M20 12a8 8 0 1 1-2.4-5.7M20 4v4.5h-4.5",
  history: "M4 12a8 8 0 1 0 2.4-5.7M4 4v4.5h4.5M12 8v4.5l3 2",
  lock: "M7.5 11V8a4.5 4.5 0 0 1 9 0v3M5 11h14v10H5V11Zm7 4v2",
  shield: "M12 3 19 6v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3Z",
  phone: "M6.5 3.5h3l1.5 4-2 1.5a11 11 0 0 0 6 6l1.5-2 4 1.5v3a2 2 0 0 1-2 2A16 16 0 0 1 4.5 5.5a2 2 0 0 1 2-2Z",
  calendar: "M4.5 6h15v14h-15V6Zm0 4.5h15M8.5 3.5v4M15.5 3.5v4",
  key: "M14.5 14a5 5 0 1 0-4.6-3L3.5 17.5V20.5h3v-2h2v-2h2l1.4-1.4a5 5 0 0 0 2.6-1.1ZM16.5 7.5h.01",
  globe: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM3 12h18M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-5.5-3.5-9s1-6.5 3.5-9Z",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size }: { name: IconName; size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size ?? 24} height={size ?? 24} fill="none" stroke="currentColor"
         strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d={PATHS[name]} />
    </svg>
  );
}

/** 帳簿の罫と印をかたどったロゴ（自作）。 */
export function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg viewBox="0 0 32 32" width={size} height={size} aria-hidden="true" focusable="false">
      <rect x="1" y="1" width="30" height="30" rx="6" fill="var(--ledger)" />
      <path d="M8 10h16M8 16h16M8 22h9" stroke="var(--on-ledger)" strokeWidth="2.2" strokeLinecap="round" />
      <rect x="19" y="19" width="7" height="7" rx="1.5" fill="none" stroke="var(--on-ledger)" strokeWidth="1.8" />
    </svg>
  );
}
